import { useState, useEffect } from 'react';
import type PermittedUser from '../models/permitted-user';
import { getAllUsersByOfficeId } from '../services/users.services';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';

interface InitialUserState {
  readonly error?: boolean;
}

interface UsersState extends InitialUserState {
  readonly users?: PermittedUser[];
}

interface Props {
  readonly id: string | undefined;
}

const useUsers = ({ id }: Props): UsersState => {
  const [state, setState] = useState<UsersState>({});
  const keycloak = useKeycloak();

  useEffect(() => {
    const getUsers = async (): Promise<void> => {
      try {
        if (!id || id === '') {
          return;
        }

        const users = (await getAllUsersByOfficeId(id, keycloak)) ?? [];
        setState({ users });
      } catch (error) {
        setState({ error: true });
      }
    };

    getUsers();
  }, [setState, keycloak, id]);

  return state;
};

export default useUsers;
